import axios from 'axios';
import { convertArrayToObject } from '../../utils/funciones';
import * as etiquetas from '../../ApplicationResources';

export const obtieneEstados = async(idProceso, idDetalle, tipoCapturaSistema, idEstado, idDistrito, idMunicipio, rol) => {

    try{
        const response = await axios.post(process.env.REACT_APP_API_URL 
                                        + '/centralReclutaSEyCAE/ws/obtieneEstados',
                                        {
                                            idSistema: etiquetas.idSistema,
                                            idProceso,
                                            idDetalle,
                                            tipoCapturaSistema,
                                            idEstado,
                                            idDistrito,
                                            idMunicipio,
                                            rol
                                        });
        if(response.data
            && response.data.code === 200
            && response.data.data) {
            return convertArrayToObject(response.data.data, 'idEstado');
        }
    }catch(error){
        console.error("Error al obtener los estados: ", error);
    }      

    return undefined;
};

export const obtieneProcesosDetalle = async(idEstado, idDistrito, idMunicipio, ambitoUsuario) => {
    try{
        const response = await axios.post(process.env.REACT_APP_API_URL 
                                        + '/centralReclutaSEyCAE/ws/obtieneProcesosDetalle',
                                        {
                                            idSistema: etiquetas.idSistema,
                                            idEstado,
                                            idDistrito,
                                            idMunicipio,
                                            ambitoUsuario
                                        });
        if(response.data
            && response.data.code === 200
            && response.data.data) {
            return convertArrayToObject(response.data.data, 'idDetalleProceso');
        }
    }catch(error){
        console.error("Error al obtener los procesos electorales: ", error);
    }      

    return undefined;
};

export const obtieneDistritos = async(idProceso, idDetalle, tipoCapturaSistema, idEstado, idDistrito, idMunicipio, ambitoUsuario ) => {

    try{
        const response = await axios.post(process.env.REACT_APP_API_URL 
                                        + '/centralReclutaSEyCAE/ws/obtieneDistritos', 
                                        {
                                            idSistema: etiquetas.idSistema,
                                            idProceso,
                                            idDetalle,
                                            tipoCapturaSistema,
                                            idEstado,
                                            idDistrito,
                                            idMunicipio,
                                            ambitoUsuario
                                        });
        if(response.data
            && response.data.code === 200
            && response.data.data) {
            return convertArrayToObject(response.data.data, 'idDistrito');
        }
    }catch(error){
        console.error("Error al obtener los distritos: ", error);
    }      

    return undefined;
};

export const obtenerRutaPublicador = async (idProcesoElectoral, idDetalleProceso, idEstadoUsuario, idDistritoUsuario, rolUsuario, nombreUsuario, nombreProceso) => {
    try{
        var datosUsuario = { idEstado: idEstadoUsuario,
            idDistrito: idDistritoUsuario,
            rolUsuario: rolUsuario,
            usuario: nombreUsuario,
        nombreProceso : nombreProceso
        };

        var postData = {
        idProceso : idProcesoElectoral,
        idDetalle : idDetalleProceso,
        idEtiqueta : etiquetas.ID_ETIQUETA_RUTA_PUBLICADOR,
        datosUsuario : datosUsuario
        }

        const response = await axios.post(process.env.REACT_APP_API_URL +
            "/centralReclutaSEyCAE/ws/obtenerRutaPublicador", postData,
                {
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    }
                }
        );

        return response.data !== null ? response.data.replace(/['"]+/g, '') : "";
    }
    catch(error) {
    console.error("Error al obtener la ruta del publicador");
    }
    
    return undefined;
}